(() => {
  'use strict';

  const GA4_ID = 'G-QL7GZ6VQTF';
  const TARGET_PATH = '/collections/brake-drum-centering-sleeve';
  const COLLECTION_NAME = 'VibraSavers Centering Kits';
  const ALLOWED_SOURCES = new Set([
    'home_vibrasavers_feature',
    'home_vibrasavers_card',
    'header_shop_vibrasavers'
  ]);

  if (!window.Shopify || String(window.Shopify.country || '').toUpperCase() !== 'US') return;

  const routeRoot = window.Shopify.routes?.root || '/';
  const normalizePath = (pathname) => pathname.replace(/^\/es(?=\/)/, '') || '/';

  function sourceFromAnchor(anchor) {
    if (!anchor?.href) return null;

    let url;
    try {
      url = new URL(anchor.href, window.location.origin);
    } catch (_) {
      return null;
    }

    if (url.origin !== window.location.origin || normalizePath(url.pathname) !== TARGET_PATH) return null;

    const explicitSource = url.searchParams.get('tts_cta');
    if (ALLOWED_SOURCES.has(explicitSource)) return explicitSource;

    if (anchor.closest('[id*="collection_list_LUEVP9"]')) return 'home_vibrasavers_card';
    if (anchor.closest('header')) return 'header_shop_vibrasavers';
    return null;
  }

  function isRecentDuplicate(source) {
    try {
      const now = Date.now();
      const previous = JSON.parse(sessionStorage.getItem('tts_last_cta_event') || 'null');
      sessionStorage.setItem('tts_last_cta_event', JSON.stringify({ source, at: now }));
      return previous?.source === source && now - Number(previous.at || 0) < 5000;
    } catch (_) {
      return false;
    }
  }

  function sendToGa4(source, destination) {
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () {
      window.dataLayer.push(arguments);
    };

    window.gtag('event', 'tts_home_cta_click', {
      send_to: GA4_ID,
      cta_source: source,
      cta_location: source.startsWith('header_') ? 'header' : 'homepage',
      collection_name: COLLECTION_NAME,
      collection_handle: 'brake-drum-centering-sleeve',
      link_url: destination
    });
  }

  function persistInCart(source) {
    const body = JSON.stringify({
      attributes: {
        'TTS CTA Source': source,
        'TTS CTA Destination': COLLECTION_NAME
      }
    });

    return fetch(`${routeRoot}cart/update.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body,
      keepalive: true
    }).catch(() => null);
  }

  function track(source, destination) {
    if (!ALLOWED_SOURCES.has(source)) return;

    if (!isRecentDuplicate(source)) sendToGa4(source, destination);
    void persistInCart(source);
  }

  document.addEventListener('click', (event) => {
    const anchor = event.target.closest?.('a[href]');
    const source = sourceFromAnchor(anchor);
    if (source) track(source, anchor.href);
  }, true);

  const landingUrl = new URL(window.location.href);
  const landingSource = landingUrl.searchParams.get('tts_cta');
  if (normalizePath(landingUrl.pathname) === TARGET_PATH && ALLOWED_SOURCES.has(landingSource)) {
    track(landingSource, landingUrl.href);
    landingUrl.searchParams.delete('tts_cta');
    window.history.replaceState({}, '', `${landingUrl.pathname}${landingUrl.search}${landingUrl.hash}`);
  }
})();
